export default __webpack_public_path__ + "static/media/959.ad460531.gif";